import { captureError } from "@/lib/monitoring";
import { useDailyEvent } from "@daily-co/daily-react";
import { useSetAtom } from "jotai";
import { useCallback } from "react";
import { callPanelOpenAtom, dailyErrorAtom } from "../atoms/videoCallAtoms";
import { getCopyForDailyError } from "../utils/utils";

export const useDailyErrorHandling = () => {
  const setDailyError = useSetAtom(dailyErrorAtom);
  const setCallPanelOpen = useSetAtom(callPanelOpenAtom);

  const handleDailyError = useCallback(
    // biome-ignore lint/suspicious/noExplicitAny: Daily error event is not typed well
    (e: any) => {
      const copy = getCopyForDailyError(e.error?.type);
      setCallPanelOpen(false);
      if (copy) setDailyError(copy.body);
      else captureError(new Error(`Error in video call: ${e}`));
    },
    [setCallPanelOpen, setDailyError],
  );

  useDailyEvent("error", handleDailyError);
  useDailyEvent("camera-error", handleDailyError);
};
